/**
 * Single source of truth for per-brand assets/strings.
 *
 * The active brand is chosen at BUILD time by the `VUE_APP_BRAND` environment
 * variable (set in `.env.production` / `.env.development`, or by CI). Unknown or
 * missing values fall back to `vfxanh`. There is one build per brand.
 *
 * This module is intentionally side-effect free. The logo paths are pushed into
 * the layout config inside `config.module.js`; favicon/title are baked into
 * `public/index.html` at build time via `vue.config.js` (html template params)
 * and kept in sync per route by `App.vue`; the Vuetify primary color is read in
 * `core/plugins/vuetify.js`; the remaining strings are exposed to components via
 * `Vue.prototype.$brand` (see `main.js`).
 */

const BRANDS = {
  vfxanh: {
    key: 'vfxanh',
    title: 'VFXanh',
    faviconPath: '/vinfast.png',
    logos: {
      sidebar: 'media/logos/logo-light.png', // -> self.logo.dark (Brand.vue, theme="dark")
      header: 'media/logos/logo-light.png', //  -> self.logo.brand (_TopHeader/HeaderMobile)
      loader: 'media/logos/logo-vin.png', //    -> loader.logo (page loader + list pages)
      login: 'media/logos/logo-light.png', //   Auth.vue aside logo
    },
    loginBg: 'media/bg/bg-group.png',
    loginAsideColor: '#7EDAE6',
    primaryColor: '#29ABC9', // sky blue tuned to harmonize with loginAsideColor (#7EDAE6) while keeping white button text readable
    loginBrandLogo: '/media/logos/ddv2.png', // Login.vue top logo
    externalLink: 'https://didongviet.vn/',
    merchantName: 'VFXanh',
    merchantLabel: 'VF', // short badge shown next to product names (MerchantLabel) for the own merchant (merchantId 1)
    sidebarLogoAlign: 'flex-start', // Brand.vue aside logo alignment (wide logo looks fine left)
  },
  neg: {
    key: 'neg',
    title: 'NEG',
    faviconPath: '/neg.png',
    logos: {
      sidebar: 'media/logos/neg.webp',
      header: 'media/logos/neg.webp',
      loader: 'media/logos/neg.webp',
      login: 'media/logos/neg.webp',
    },
    loginBg: 'media/bg/bg-group.png', // reuse vfxanh login background
    loginAsideColor: '#303133',
    primaryColor: '#bc181f',
    loginBrandLogo: '/media/logos/neg.webp', // Login.vue top logo
    externalLink: 'https://didongviet.vn/', // shared parent-company site
    merchantName: 'NEG',
    merchantLabel: 'NEG', // short badge shown next to product names (MerchantLabel) for the own merchant (merchantId 1)
    sidebarLogoAlign: 'center', // Brand.vue aside logo alignment (narrow logo centers better)
  },
};

export function detectBrand() {
  const key = process.env.VUE_APP_BRAND;
  return (key && BRANDS[key]) || BRANDS.vfxanh;
}

export const activeBrand = detectBrand();
export { BRANDS };
export default activeBrand;
